import {Component, OnDestroy, OnInit} from "@angular/core";
import {LoggerService} from '../common/logger.service';
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {combineLatest, noop, Observable, Subscription} from "rxjs";
import {GqlPaymentService} from "../../checkout/payment/gql-payment.service";
import {catchError, map, switchMap} from 'rxjs/operators';
import {IPaymentNotifyResponse} from "./payment-callback";
import {Constants} from "../constants";
import {uxCartRouterCommands} from "../util/locale-util";
import {BaseComponent} from "../base.component";
import {UserService} from "../common/user.service";

@Component({
    selector: 'payment-callback',
    templateUrl: 'payment-callback.component.html',
    standalone: false
})
export class PaymentCallbackComponent extends BaseComponent implements OnInit, OnDestroy {

    errorTag: string;
    loading: boolean;
    mode: string;
    subscription: Subscription;

    constructor(private activatedRoute: ActivatedRoute,
                private gqlPaymentService: GqlPaymentService,
                private router: Router,
                userService: UserService,
                loggerService: LoggerService) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.mode = this.activatedRoute.snapshot.data['mode'];
        this.loading = true;
        if (this.mode == 'notify') {
            this.subscription = combineLatest([this.activatedRoute.paramMap, this.activatedRoute.queryParamMap])
                .pipe(
                    switchMap(([pathVariables, queryParams]) => this.notifyPayment(pathVariables, queryParams)),
                    catchError(async () => this.showError())
                ).subscribe((response: IPaymentNotifyResponse) => this.handleResponse(response));
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    showError() {
        this.errorTag = `${Constants.CHECKOUT_TAG_ERROR_PREFIX}apm`;
        this.loading = false;
    }

    notifyPayment(pathVariables: ParamMap, queryParams: ParamMap): Observable<IPaymentNotifyResponse> {
        const paymentId: string = pathVariables.get('paymentId');
        const paymentMethodType: string = pathVariables.get('paymentMethodType');
        return this.gqlPaymentService.notifyPayment({
            paymentMethodType: paymentMethodType,
            paymentId: paymentId,
            transactionId: PaymentCallbackComponent.getTransactionId(paymentMethodType, queryParams)
        }).pipe(map((response: IPaymentNotifyResponse) => {
            response.paymentMethodType = paymentMethodType;
            return response;
        }));
    }

    handleResponse(response: IPaymentNotifyResponse) {
        if (response?.orderId) {
            this.loading = false;
            this.router
                .navigate(uxCartRouterCommands(Constants.CHECKOUT_STATE, Constants.CHECKOUT_CONFIRM_STATE, response.orderId), {queryParams: {paymentMethod: response.paymentMethodType, result: response.success}})
                .then(noop);
        } else {
            this.showError();
        }
    }

    private static getTransactionId(paymentMethodType: string, queryParams: ParamMap): string | undefined {
        return paymentMethodType == Constants.PMT_KCP ? queryParams.get('ordr_idxx') : undefined;
    }
}
